<div class="content-block light-control-host">
  <div>
    <h1>Add Ons</h1>
    <div>
      Add ons extend {{ uiService.productName }}'s replications capabilities to resources beyond your AWS environments.
      You define integrations with these 3rd party services here and then associate them with your applications where
      you need them.
    </div>
  </div>

  <h3 class="margin-top">Configured Add Ons</h3>
  @if (licensedForIntegrations) {
    <ng-container *ngLet="integrations as definedIntegrations">
      <table class="arpio-table">
        <tr>
          <th class="strong-text integration-column">Add On Type</th>
          <th class="strong-text name-column">Description</th>
          <th class="strong-text action-column">Actions</th>
        </tr>
        @if (definedIntegrations.length === 0) {
          <tr>
            <td colspan="3">No add ons have been configured.</td>
          </tr>
        }
        @for (integration of definedIntegrations; track integration) {
          <tr
            account-integration
            [integration]="integration"
            (delete)="deleteIntegration(integration)"
            (edit)="editIntegration(integration)"
          ></tr>
        }
      </table>
    </ng-container>
    <div class="flex-center-row control-header">
      <div class="spacer"></div>
      <button class="arpio-button small-button" (click)="configureNewIntegration()">Configure New Add On</button>
    </div>
  } @else {
    Your {{ uiService.productName }} account is not licensed for any add ons.
  }
</div>

<modal-dialog #editIntegrationDialog [dialogTemplate]="editIntegrationDialogTemplate"></modal-dialog>

<ng-template #editIntegrationDialogTemplate>
  <edit-integration-dialog
    [integration]="integrationToEdit"
    [saving]="savingIntegration"
    (cancel)="dismissEditModal()"
    (save)="commitIntegration($event)"
  >
  </edit-integration-dialog>
</ng-template>
